module.exports = __webpack_public_path__ + "static/img/banners_ir_en.1aac6c1c.jpg";